export class RefreshToken {
  accessToken: string | undefined;
  refreshToken: string | undefined;
  tokenType?: string | undefined;
}
